import { handleActions } from 'redux-actions'
import {
  availabilitiesSetDays,
  availabilitiesStartLoading,
  availabilitiesSuccessLoading,
  availabilitiesErrorLoading,
  setAvailabilitiesFilter
} from './actions'

const getDefaultState = () => ({
  isLoading: false,
  loadingError: null,
  days: [],
  month: new Date().getMonth(),
  year: new Date().getFullYear(),
  filter: 'ALL'
})

export const reducer = handleActions(
  {
    [availabilitiesSetDays]: (state, { payload }) => ({
      ...state,
      days: payload
    }),
    [availabilitiesStartLoading]: state => ({
      ...state,
      isLoading: true,
      days: []
    }),
    [availabilitiesSuccessLoading]: state => ({
      ...state,
      isLoading: false
    }),
    [availabilitiesErrorLoading]: (state, { payload }) => ({
      ...state,
      loadingError: payload
    }),
    [setAvailabilitiesFilter]: (state, { payload }) => ({
      ...state,
      filter: payload
    })
  },
  getDefaultState()
)
